import React from 'react'
import { useClearRefinements } from 'react-instantsearch'
import { UseNumericMenuProps, useNumericMenu } from 'react-instantsearch-core'

import ItemCheckbox from 'components/atoms/item-checkbox'
import ItemSelectContainer from 'components/organisms/item-select-container'

export type NumericMenuSelect = {
  label: string
  end: number
  start: number
}

export type NumericMenuProps = React.ComponentProps<'div'> & UseNumericMenuProps

const RefinementNumericMenu = (props: NumericMenuProps) => {
  const { attribute } = props
  const { items, refine } = useNumericMenu({ ...props })

  const { refine: clearRefinement } = useClearRefinements({
    includedAttributes: [attribute],
  })

  return (
    <ItemSelectContainer>
      {items.map((item) => (
        <ItemCheckbox
          key={item.label}
          isSelected={item.isRefined}
          id={attribute + item.label}
          name={item.label}
          label={item.label}
          onChange={(isChecked) => {
            if (!isChecked) {
              clearRefinement()
              return
            }

            refine(item.value)
          }}
        />
      ))}
    </ItemSelectContainer>
  )
}

export default RefinementNumericMenu
